module.exports = __webpack_public_path__ + "img/Атырау облысы.51929510.png";